export interface IDocumentSearchRequest {
  fileName: string | undefined
  description: string | undefined
  fileDateStart: Date | undefined
  fileDateEnd: Date | undefined
  category: string | undefined
  type: string | undefined
  provider: string | undefined
  patientFirstName: string | undefined
  patientLastName: string | undefined
  patientDOB: Date | undefined
  freeformAddress: string | undefined
  dateOfServiceStart: Date | undefined
  dateOfServiceEnd: Date | undefined
  bodyPart: string | undefined
  takeoverOfCareDateStart: Date | undefined
  takeoverOfCareDateEnd: Date | undefined
  mmiDateStart: Date | undefined
  mmiDateEnd: Date | undefined
  episodeOfCareNumberOrLegacyId: string | undefined
  page?: number
  pageSize?: number
  sorting?: { column: string; order: string } | undefined
}

export class DocumentSearchRequest implements IDocumentSearchRequest {
  public fileName: string | undefined
  public description: string | undefined
  public fileDateStart: Date | undefined
  public fileDateEnd: Date | undefined
  public category: string | undefined
  public type: string | undefined
  public provider: string | undefined
  public patientFirstName: string | undefined
  public patientLastName: string | undefined
  public patientDOB: Date | undefined
  public freeformAddress: string | undefined
  public dateOfServiceStart: Date | undefined
  public dateOfServiceEnd: Date | undefined
  public bodyPart: string | undefined
  public takeoverOfCareDateStart: Date | undefined
  public takeoverOfCareDateEnd: Date | undefined
  public mmiDateStart: Date | undefined
  public mmiDateEnd: Date | undefined
  public episodeOfCareNumberOrLegacyId: string | undefined
  public page?: number | undefined
  public pageSize?: number | undefined
  public sorting?: { column: string; order: string } | undefined
}
